export default __webpack_public_path__ + "static/media/image 6.fe477820.png";